import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { ArrowLeft } from "lucide-react";

interface BackButtonProps {
  onClick: () => void;
  label?: string;
  isVisible?: boolean;
}

export const BackButton: React.FC<BackButtonProps> = ({
  onClick,
  label = "Voltar",
  isVisible = true,
}) => {
  if (!isVisible) return null;

  return (
    <Flex gap="8px" cursor="pointer" onClick={onClick}>
      <ArrowLeft color="#086AA9" size="20px" />
      <Text
        fontWeight="400"
        fontSize="sm"
        color="#086AA9"
        textDecoration="underline"
      >
        {label}
      </Text>
    </Flex>
  );
};
